module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-scary.c628851f.png";